import { Action, createSlice } from "@reduxjs/toolkit";
import { RootState } from "./store";

interface NavbarState {
  drawerState: 'open' | 'closed'
}

const initialState: NavbarState = {
  drawerState: 'closed'
}

const navbarSlice = createSlice({
  name: 'navbar',
  initialState,
  reducers: {
    changeToOpen(state, action: Action) {
      state.drawerState = 'open'
    },
    changeToClosed(state, action: Action) {
      state.drawerState = 'closed'
    }
  }
})

// Export the auto-generated action creator with the same name
export const { changeToOpen, changeToClosed } = navbarSlice.actions;

// Export the generated reducer function
export default navbarSlice.reducer;
export const selectNavbar = (state: RootState) => state.navbar;